import { render } from "./connect-button.vue?vue&type=template&id=483f9f58&lang=pug"
import script from "./connect-button.vue?vue&type=script&lang=js"
export * from "./connect-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__